import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "zakat-donation-wrapper" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lifeline_donation_modal = _resolveComponent("lifeline-donation-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Zakat Donation Button "),
    _createElementVNode("button", {
      onClick: $setup.openZakatModal,
      disabled: !$setup.zakatAmount || $setup.zakatAmount <= 0,
      class: _normalizeClass(['zakat-donate-btn', { 'disabled': !$setup.zakatAmount || $setup.zakatAmount <= 0 }])
    }, _toDisplayString($setup.zakatAmount > 0 ? `Donate Zakat ($${$setup.zakatAmount.toFixed(2)})` : 'Calculate Zakat First'), 11 /* TEXT, CLASS, PROPS */, _hoisted_2),
    _createCommentVNode(" Include the modal component "),
    _createVNode(_component_lifeline_donation_modal, {
      id: $props.postId,
      dstyle: 1,
      onClose: $setup.closeModal
    }, null, 8 /* PROPS */, ["id"])
  ]))
}